
import SignupForm from "@/components/login/SignupForm.vue";

export default {
  name: "SignupView",
  components: { SignupForm },
};
